import React from 'react'
import { inject, observer } from 'mobx-react'
import { Select, Spin } from 'antd'
import cancellationRequests from '@services/cancellationRequests'
import { CANCELLATION_REASON_TYPES } from '@texts/cancellation'
import { alertPopup } from '@utils/popup'

@inject((store: any) => {
    const { cancellationRequestStore } = store
    return {
        cancellationRequestStore
    }
})
@observer
class EditStatus extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            request_reason: props.requestReason || null,
            saveLoading: false
        }
    }

    handleReasoSelect = request_reason => {
        this.setState({ request_reason })
    }

    sendUpdate = () => {
        const {
            cancellationRequestStore: { updateListLocally },
            recordId
        } = this.props

        const { request_reason } = this.state
        if (!request_reason) {
            this.props.cancel()
            return
        }

        this.setState({ saveLoading: true }, () => {
            cancellationRequests
                .updateCancellationRequest({ requestId: recordId, request_reason })
                .then(res => {
                    updateListLocally({ request: res.data.cancellation_request })
                    this.setState({ saveLoading: false }, () => {
                        this.props.cancel()
                    })
                })
                .catch(error => {
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון נכשל' })
                    this.setState({ saveLoading: false })
                    if (this.props.cancellationRequestStore.refreshOnConflict(error)) this.props.cancel()
                })
        })
    }

    render() {
        const { cancel } = this.props
        const { request_reason, saveLoading } = this.state

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div
                    style={{
                        marginBottom: '6px',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '75px',
                        height: '25px'
                    }}
                >
                    {!saveLoading ? (
                        <>
                            <span onClick={() => this.sendUpdate()} style={{ cursor: 'pointer' }}>
                                {'שמירה'}
                            </span>
                            <span onClick={cancel} style={{ cursor: 'pointer', marginRight: '7px' }}>
                                {'ביטול'}
                            </span>
                        </>
                    ) : (
                        <Spin />
                    )}
                </div>
                {/*
                    The dropdown is portalled to document.body, so the table body's
                    overflow can no longer clip it — this is the actual fix.
                    dropdownMenuStyle maxHeight 400px fits all ten reasons
                    (10 × ~32px ≈ 320px), so there is no inner scrolling.
                    dropdownMatchSelectWidth false sizes the list to its content
                    rather than the narrow cell.
                */}
                <Select
                    value={request_reason || undefined}
                    onChange={this.handleReasoSelect}
                    placeholder={'סיבת הבקשה'}
                    style={{ minWidth: '180px' }}
                    dropdownMenuStyle={{ maxHeight: '400px' }}
                    dropdownMatchSelectWidth={false}
                    defaultOpen
                >
                    {Object.keys(CANCELLATION_REASON_TYPES).map(key => (
                        <Select.Option key={key} value={key}>
                            {CANCELLATION_REASON_TYPES[key]}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        )
    }
}

export default EditStatus
